/**
 * WebGL layers cannot read CSS custom properties, so the map keeps its own copy
 * of the palette. These are the hex equivalents of the tokens in index.css.
 */
export const mapPalette = (theme: 'light' | 'dark') =>
  theme === 'dark'
    ? {
        cluster: '#8b6bf5',
        clusterAlert: '#ff6a63',
        clusterText: '#ffffff',
        label: '#e8eaf0',
        labelHalo: '#151821',
        selected: '#a58cf8',
        geofenceFill: '#8b6bf5',
        geofenceLine: '#a58cf8',
        trail: '#8b6bf5',
        trailCasing: '#151821',
        replay: '#35d98c',
      }
    : {
        cluster: '#7b5cf0',
        clusterAlert: '#e8433f',
        clusterText: '#ffffff',
        label: '#20232e',
        labelHalo: '#ffffff',
        selected: '#7b5cf0',
        geofenceFill: '#7b5cf0',
        geofenceLine: '#7b5cf0',
        trail: '#7b5cf0',
        trailCasing: '#ffffff',
        replay: '#1aa563',
      };

/**
 * Font stacks must exist on the glyph server named in the style. The
 * openmaptiles endpoint serves the Open Sans family; asking it for anything
 * else returns an HTML error page that MapLibre cannot parse, and every text
 * layer silently falls back to slow local codepoint rendering.
 */
/** Status ramp for WebGL layers; mirrors STATUS_HEX in lib/vehicle-status. */
export const statusHex = (theme: 'light' | 'dark') =>
  theme === 'dark'
    ? { moving: '#35d98c', idle: '#f7bb3d', offline: '#9aa2b6', alert: '#ff6a63' }
    : { moving: '#1aa563', idle: '#e0980f', offline: '#8189a0', alert: '#e8433f' };

export const MAP_FONT = ['Open Sans Bold'];
export const MAP_FONT_REGULAR = ['Open Sans Regular'];
